import React from "react";
import { motion } from "framer-motion";
import { ClipboardCheck, Truck, Wrench } from "lucide-react";

const steps = [
  {
    no: "01",
    icon: ClipboardCheck,
    title: "Pick your machine",
    desc:
      "Tell us your site, footfall and product mix. We propose the right model from our Refuel range — for purchase.",
  },
  {
    no: "02",
    icon: Truck,
    title: "We deliver & install",
    desc:
      "On-site delivery, installation, branding, cashless payment setup, IoT activation and staff onboarding — turnkey.",
  },
  {
    no: "03",
    icon: Wrench,
    title: "AMC keeps it running",
    desc:
      "Optional Annual Maintenance Contract: pan-India technicians, spare parts and remote diagnostics — zero downtime.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      className="relative py-24 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-2xl mb-14">
          <div className="text-[11px] uppercase tracking-[0.25em] text-emerald-600 mb-3">
            How It Works
          </div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tighter text-zinc-950">
            Three steps.
            <br />
            <span className="text-zinc-500">From quote to live machine.</span>
          </h2>
        </div>

        <div className="relative grid md:grid-cols-3 gap-5 md:gap-6">
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-px bg-gradient-to-r from-transparent via-emerald-300 to-transparent" />

          {steps.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.no}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                data-testid={`step-card-${i}`}
                className="relative bg-white border border-zinc-200 rounded-3xl p-7 md:p-8 hover:border-emerald-400 hover:shadow-lg hover:shadow-zinc-900/5 transition-all"
              >
                <div className="flex items-start justify-between mb-8">
                  <div className="w-14 h-14 rounded-2xl bg-emerald-50 border border-emerald-100 flex items-center justify-center text-emerald-600">
                    <Icon className="w-6 h-6" />
                  </div>
                  <div className="font-display text-5xl font-bold text-zinc-100 tracking-tighter">
                    {s.no}
                  </div>
                </div>
                <h3 className="font-display text-xl md:text-2xl font-semibold text-zinc-950 tracking-tight">
                  {s.title}
                </h3>
                <p className="mt-3 text-zinc-600 text-sm md:text-base leading-relaxed">
                  {s.desc}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
